"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showType = exports.Constructor = exports.TypeKind = void 0;
const util_1 = require("../../util");
var TypeKind;
(function (TypeKind) {
    TypeKind["Variable"] = "Variable";
    TypeKind["Boolean"] = "Boolean";
    TypeKind["Number"] = "Number";
    TypeKind["BigInt"] = "BigInt";
    TypeKind["Character"] = "Character";
    TypeKind["Function"] = "Function";
    TypeKind["Polymorphic"] = "Polymorphic";
})(TypeKind = exports.TypeKind || (exports.TypeKind = {}));
exports.Constructor = {
    Tuple: {
        2: '2-tuple',
        3: '3-tuple',
        4: '4-tuple',
        5: '5-tuple',
        6: '6-tuple',
    },
    Array: 'Array',
};
function showType(type) {
    switch (type.kind) {
        case TypeKind.Number:
            return 'Number';
        case TypeKind.Boolean:
            return 'Bool';
        case TypeKind.Character:
            return 'Char';
        case TypeKind.BigInt:
            return 'Bigint';
        case TypeKind.Function:
            return showFunction(type);
        case TypeKind.Variable:
            return type.name;
        case TypeKind.Polymorphic:
            return showPolymorphicType(type);
        default:
            util_1.assertUnreachable(type);
    }
}
exports.showType = showType;
function isTuple(type) {
    return Object.values(exports.Constructor.Tuple).includes(type.constructor);
}
function showPolymorphicType(type) {
    const paramTypes = type.parameters.map(showType);
    if (isTuple(type)) {
        return `(${paramTypes.join(', ')})`;
    }
    else if (type.constructor == exports.Constructor.Array) {
        return `[${showType(type.parameters[0])}]`;
    }
    else {
        return `${type.constructor} ${paramTypes.join(', ')})`;
    }
}
function showFunction(type) {
    const { input, output } = type;
    const inputStr = input.kind === TypeKind.Function ? `(${showType(input)})` : `${showType(input)}`;
    return `${inputStr} -> ${showType(output)}`;
}
//# sourceMappingURL=type.js.map